<template>  
  <DefaultLayout v-if="is_authenticated">
    <RouterView></RouterView>
  </DefaultLayout>
  <LoginLayout v-else></LoginLayout>
</template>
<script setup lang="ts">
import { RouterView } from 'vue-router';
import DefaultLayout from './components/Layouts/DefaultLayout.vue';
import LoginLayout from './components/Layouts/LoginLayout.vue';
import { current_user } from './store/auth';
import { computed } from 'vue';
const is_authenticated = computed(() => {
  return current_user.value !== null
})



</script>